/* import __COLOCATED_TEMPLATE__ from './help-center-audience-cell.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { audienceRoles } from 'embercom/models/data/matching-system/matching-constants';
import { audienceRoleLabel } from 'embercom/helpers/audience-types';

interface Args {
  helpCenterAudienceRoles?: string[];
  isFolder: boolean;
}

interface Signature {
  Args: Args;
}

const HC_AUDIENCE_RESTRICTED = 'restricted';
const ALL_AUDIENCE_ROLES = [audienceRoles.users, audienceRoles.visitors, audienceRoles.leads];

export default class HelpCenterAudienceCell extends Component<Signature> {
  @service declare intl: IntlService;

  get labels(): string[] {
    let roles = this.args.helpCenterAudienceRoles;
    if (!roles || roles.length === 0) {
      return [this.intl.t('knowledge-hub.filterable-list.filters.help-center-audience.not-set')];
    }

    if (roles.includes(HC_AUDIENCE_RESTRICTED)) {
      return [this.intl.t('knowledge-hub.filterable-list.filters.help-center-audience.restricted')];
    }

    if (ALL_AUDIENCE_ROLES.every((role) => roles.includes(role))) {
      return [this.intl.t('knowledge-hub.filterable-list.filters.help-center-audience.everyone')];
    }

    return roles.map((role) => audienceRoleLabel(role));
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::Table::Cells::HelpCenterAudienceCell': typeof HelpCenterAudienceCell;
    'knowledge-hub/filterable-list/table/cells/help-center-audience-cell': typeof HelpCenterAudienceCell;
  }
}
